import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

export default function InterpretAd() {
  const { t } = useTranslation()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    }
  }, [])
  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', height: '90vh', textAlign: 'center' }}
      data-ad-client="ca-pub-7107296404320558"
      data-ad-slot="8890839340"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  )
}
